<template>
  <div>
    <div class="flex items-start justify-between pricebookbtns pb-2.5 px-2">
      <button @click="nrgItemsClicked()"
        class="mobile:px-2 tablet:px-4 mobile:!py-2.5 laptop:py-2 flex justify-center items-center rounded-[5px] border-1 border-[#092E87] mobile:bg-[#092E87] tablet:bg-[#fff]">
        <span v-if="quoteDetail.partner_info.show_approved_item_text == 1"
          class="text-[12px] font-normal laptop:text-[14px] font-lato mobile:text-[#fff] tablet:text-[#092E87]">
          Select Items from {{ quoteDetail.partner_info.company_name }} Approved list </span>
        <span v-else class="text-[12px] font-normal laptop:text-[14px] font-lato mobile:text-[#fff] tablet:text-[#092E87]">
          Select Items from Pricebook
        </span>
      </button>
      <div class="flex flex-col gap-1 addmanualyitems">
        <button
          class="mobile:px-1.5 tablet:px-4 mobile:!py-2.5 laptop:py-2 flex justify-center items-center rounded-[5px] border-1 border-[#092E87] mobile:bg-[#092E87] tablet:bg-[#fff]"
          @click="addItemManually()">
          <span class="text-[12px] font-normal laptop:text-[14px] font-lato mobile:text-[#fff] tablet:text-[#092E87]">
            Add Items Manually </span>
        </button>
        <p v-if="isPartnerQuote && isShowApproved" class="m-0 text-[12px] font-lato text-[#FE5000]">(Not approved by {{
          quoteDetail.partner_info.company_name
        }})
        </p>
      </div>
    </div>

    <div v-if="manualItems.length > 0" class="grid grid-cols-1 laptop:grid-cols-2 gap-4 mobile:max-h-[450px] laptop:max-h-max overflow-y-auto py-3 px-2
      [scrollbar-width:thin] 
      [scrollbar-color:#ff5b00_#EFEFEF]
      [&&::-webkit-scrollbar]:w-[6px]
      [&&::-webkit-scrollbar-track]:bg-[#EFEFEF]
      [&&::-webkit-scrollbar-track]:!rounded-full
      [&&::-webkit-scrollbar-thumb]:bg-[#ff5b00]
      [&&::-webkit-scrollbar-thumb]:!rounded-full
      [&&::-webkit-scrollbar-thumb:hover]:bg-[#e94d00]
      [&&::-webkit-scrollbar-button]:!hidden">
      <div v-for="(items, idx) in manualItems" :key="items.value">
        <div class="relative shadow-[0_0_20px_0_rgba(0,0,0,0.15)] rounded-[10px] px-3 py-6 pb-3 ">
          <div class="flex items-center justify-between absolute -top-[10px] left-0 w-full px-3">
            <div v-if="isPartnerQuote && isShowApproved">
              <span v-if="(items.is_covered_by_nrg == 1 && quoteDetail.partner_info.service_type != 'maintenance') ||
               (items.service_part_id > 0 && quoteDetail.partner_info.service_type != 'maintenance') || 
               (items.is_evaluation_fee == 1 && items.is_covered_by_nrg == 1)"
                class="px-3 py-1.5 text-[14px] rounded-full text-[#fff] bg-[#54B435]">
                Covered by {{ quoteDetail.partner_info.company_name }}
              </span>
              <span v-else-if="(items.is_covered_by_nrg == 2 && quoteDetail.partner_info.service_type != 'maintenance') ||
               (items.is_evaluation_fee == 1 && items.is_covered_by_nrg == 2)"
                class="px-3 py-1.5 text-[14px] rounded-full text-[#fff] bg-[#54B435]">
                Partially Covered by {{ quoteDetail.partner_info.company_name }}
              </span>
              <span v-else class="px-3 py-1.5 text-[14px] rounded-full text-[#fff] bg-[#FE5000]" >
                (Not Covered)
              </span>
            </div>
          </div>
          <div v-if="items.is_deletable" class="absolute top-2 right-4 cursor-pointer flex items-center justify-end "
            @click="deleteItemClicked(items)">
            <img src="@/assets/images/delete-on-filled-orange.svg"
              class="p-2 rounded-full w-[35px] h-[35px] bg-opacity-50 bg-[#EFEFEF]" />
          </div>
          <!-- <br v-if="items.is_covered_by_nrg == 1" /> -->
          <div class="flex flex-col gap-2">
            <div>
              <label class="text-[16px] font-lato text-[#999999]">Title</label>
              <input :disabled="(items.is_max_markup_applicable == 1 || items.is_deletable == 0)" :id="'title_' + idx" type="text" v-model="items.title"
                placeholder="Enter Title" @drop.prevent @dragover.prevent
                class="form-control !rounded-[10px] !text-[16px] disabled:!bg-[#EFEFEF] disabled:!border-[#EFEFEF]" />
            </div>
            <div>
              <label class="text-[16px] font-lato text-[#999999]" v-if="
                items.is_deletable &&
                items.service != null &&
                items.service.is_service_fee_applicable == 1
              ">
                Part Cost
              </label>
              <label class="text-[16px] font-lato text-[#999999]" v-else-if="items.is_deletable"> Fee (Part + Service)
              </label>
              <label class="text-[16px] font-lato text-[#999999]" v-else-if="items.is_evaluation_fee"> Evaluation
                Fee</label>
              <div class="flex items-stretch rounded-[10px] overflow-hidden mt-1">
                
                <span class="text-[20px] px-3 h-auto flex items-center justify-center text-[#fff] bg-[#092e87]">$</span>
                <input v-if="items.is_evaluation_fee" :id="'price_' + idx" type="text" v-model="items.part_price"
                  @input="validateInputLimitation(idx, true)" placeholder="Enter Evaluation Fee" :step="0.9"
                  inputmode="decimal" pattern="[0-9]*[.]?[0-9]*" @paste="disablePaste"
                  @keypress="isNumberLimitation($event)"  @drop.prevent @dragover.prevent
                  class="form-control !rounded-l-none !rounded-r-[10px] !text-[16px] focus:!border-[#ccc]" />
                  <input v-else :id="'price_' + idx" type="text" v-model="items.part_price"
                  @input="validateInputLimitation(idx, true)" :placeholder="items.service != null &&
                    items.service.is_service_fee_applicable == 1
                    ? 'Enter Part Cost'
                    : 'Enter Fee (Part + Service)'
                    " inputmode="decimal" pattern="[0-9]*[.]?[0-9]*" :step="0.9" @paste="disablePaste"
                  @keypress="isNumberLimitation($event)"  @drop.prevent @dragover.prevent
                  class="form-control !rounded-l-none !rounded-r-[10px] !text-[16px] focus:!border-[#ccc]" />
              </div>

              <div class="min-h-[20px] w-full">
                
                <span class="text-[11px] text-red-500"
                  v-if="items.is_max_markup_applicable && (items?.part_price ?? 0) > items.max_allowed_price">Price
                  cannot exceed
                  ${{ items.max_allowed_price }}.</span>
              </div>

              <label class="mt-2 text-[16px] font-lato text-[#999999]" v-if="
                items.service != null &&
                items.service.is_service_fee_applicable == 1
              ">{{
                replaceDollar(
                  items.service.service_fee_title ?? "Service Fee ($)"
                )
              }}</label>

              <div v-if="
                items.service != null &&
                items.service.is_service_fee_applicable == 1"
                class="flex items-stretch rounded-[10px] overflow-hidden mt-1">
                <span class="text-[20px] px-3 h-auto flex items-center justify-center text-[#fff] bg-[#092e87]">$</span>
                <input v-if="!items.is_evaluation_fee" :id="'service_fee_' + idx" type="text"
                  @input="validateInputLimitation(idx, false)" v-model="items.service.price" :placeholder="'Enter ' +
                    replaceDollar(
                      items.service.service_fee_title ?? 'Service Fee ($)'
                    )
                    " :disabled="items.service.is_service_fee_editable == 0" :step="0.9" @paste="disablePaste"  @drop.prevent @dragover.prevent
                  @keypress="isNumberLimitation($event)" inputmode="decimal" pattern="[0-9]*[.]?[0-9]*"
                  class="form-control !rounded-l-none !rounded-r-[10px] !text-[16px] focus:!border-[#ccc]" />
                <input v-else placeholder="Enter Evaluation Fee" :id="'service_fee_' + idx" type="text"
                  @input="validateInputLimitation(idx, false)"
                  class="form-control !rounded-l-none !rounded-r-[10px] !text-[16px] focus:!border-[#ccc]"
                  :value="items.part_price" v-model="items.service.price" inputmode="decimal" pattern="[0-9]*[.]?[0-9]*"
                  :disabled="items.service.is_service_fee_editable == 0" :step="0.9" @paste="disablePaste"  @drop.prevent @dragover.prevent
                  @keypress="isNumberLimitation($event)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isPartnerQuote"
      class="relative shadow-[0_0_20px_0_rgba(0,0,0,0.15)] rounded-[10px] px-3 py-[16px] ml-[8px] mr-[1rem] mt-2 col-span-1 laptop:col-span-2">
      <label class="text-[16px] font-lato text-[#999999]"> {{ quoteDetail?.discount?.title || "Discount" }}</label>
      <div class="flex items-stretch rounded-[10px] overflow-hidden mt-1">
        <span class="text-[20px] px-3 h-auto flex items-center justify-center text-[#fff] bg-[#FE5000]">$</span>
        <input v-model="discount" @input="validateInputLimitationDiscount(discount)"
          class="form-control !rounded-l-none !rounded-r-[10px] !text-[16px] focus:!border-[#ccc]"
          placeholder="Enter Discount" :step="0.9" inputmode="decimal" pattern="[0-9]*[.]?[0-9]*" @paste="disablePaste" @drop.prevent
          @dragover.prevent
          @keypress="isNumberLimitation($event)">
      </div>
    </div>


    <div class="text-center mt-3 laptop:mt-5">
      <button
        class="group/finalize flex items-center mx-auto gap-2 px-2 py-1.5 rounded-full transition duration-300 border-1 border-[#FE5000] hover:bg-[#FE5000] mobile:bg-[#FE5000] tablet:bg-[#fff]
        disabled:border-[#CCCCCC] disabled:bg-transparent disabled:text-[#CCCCCC] disabled:cursor-not-allowed"
        @click="finalizeQuoteClicked()" :disabled="!((manualItems?? []).length > 0)">
        <span class="mobile:text-[#fff] tablet:text-[#FE5000] group-hover/finalize:text-[#fff] group-disabled/finalize:text-[#CCCCCC]">Finalize Quote</span>
        <img src="../../assets/images/finalize-quote-button-icon.png" alt="Finalize Quote Button Icon"
          class="w-[28px] h-[28px] mobile:hidden tablet:block group-hover/finalize:hidden group-disabled/finalize:hidden">
        <img src="../../assets/images/finalize-quote-button-hover-icon.png" alt="Finalize Quote Button Icon"
          class="w-[28px] h-[28px] mobile:block tablet:hidden group-hover/finalize:block group-disabled/finalize:hidden">
        <img src="../../assets/images/disabled-qoute.png" alt="Finalize Quote Button Icon"
          class="w-[28px] h-[28px] hidden group-disabled/finalize:block">
      </button>
    </div>

    <!-- Modal -->
    <div id="exampleModal" ref="modal" class="modal fade modal-lg" data-bs-backdrop="static" data-bs-keyboard="false"
      tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mobile:!max-w-full tablet:!max-w-[500px]">
        <NrgItems :list="manualItems" :open-modal="openModal" @event="nrgItemsCallback" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NrgItems from "@/components/nrg_items/NrgItems.vue";
import { Modal } from "bootstrap";
import { globals } from "../../main";
import { useToast } from "vue-toastification";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
const toast = useToast();

export default {
  components: {
    NrgItems,
  },
  // props: ['no_of_units'],

  data() {
    return {
      modal: null,
      manualItems: [],
      postItems: [],
      openModal: false,
      discount: '',
      isApiCalled: false,
      no_of_units: -1
    };
  },
  computed: {
    ...mapGetters(["quoteItems", "storeQuoteData", "storeQuoteItems", "quoteDetail"]),

    isPartnerQuote() {
      return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
    },

    isShowApproved() {
      return this.quoteDetail?.partner_info?.show_approved_item_text == 1 || false
    },
  },

  watch: {

    quoteItems: function () {
      this.isApiCalled = true
      this.manualItems = this.quoteItems
      this.discount = Math.abs(this.quoteDetail?.discount?.price)
    },

    // no_of_units: function () {

    //   // this.getItems()
    // },

    storeQuoteItems: function () {
      const quote = Object.assign({}, this.quoteDetail);
      quote.items = this.manualItems;
      this.updateQuoteItems(quote);
      this.setCommponent("QuoteSummary");
    },
  },

  mounted() {
  },

  methods: {
    ...mapActions(["getQuoteItems", "getQuoteItemsPartner", "postQuoteData", "setCommponent", "updateQuoteItems"]),

    setUnits(no_of_units) {
      this.no_of_units = no_of_units
      this.getItems()
    },

    getItems() {
      globals.$loader.show();
      if (this.isPartnerQuote) {
        this.getQuoteItemsPartner({
          manual_quote_id: this.$route.params.id,
          number_of_units: this.no_of_units
        });
      } else {
        this.getQuoteItems({
          manual_quote_id: this.$route.params.id,
          number_of_units: this.no_of_units
        });
      }
    },

    validateInputLimitation(idx, isPartPrice) {
      let regex = /^\d{0,5}(\.\d{0,2})?$/;
      if (isPartPrice) {
        if (!regex.test(this.manualItems[idx].part_price)) {
          this.manualItems[idx].part_price = this.manualItems[
            idx
          ].part_price.slice(0, -1);
        }
      } else {
        if (!regex.test(this.manualItems[idx].service.price)) {
          this.manualItems[idx].service.price = this.manualItems[
            idx
          ].service.price.slice(0, -1);
        }
      }
    },

    validateInputLimitationDiscount() {
      let regex = /^\d{0,5}(\.\d{0,2})?$/;
      if (!regex.test(this.discount)) {
        this.discount = this.discount.slice(0, -1);
      }
    },

    isNumberLimitation(evt) {
      evt = evt || window.event;
      const charCode = evt.which || evt.keyCode;
      const inputElement = evt.target;
      const value = inputElement.value;
      const cursorPos = inputElement.selectionStart; // Track cursor position
      // Allow control keys
      if (charCode === 8 || charCode === 46 || charCode === 9) {
        return true;
      }
      // Restrict length to 4 characters before the decimal
      const parts = value.split('.');
      if (parts.length > 1) {
        if (parts[0].length >= 4 && cursorPos <= parts[0].length) {
          evt.preventDefault();
          return false;
        }
        // Allow up to 2 digits after the decimal point
        if (parts[1].length >= 2) {
          evt.preventDefault();
          return false;
        }
      } else if (parts[0].length >= 5 && cursorPos <= parts[0].length) {
        evt.preventDefault();
        return false;
      }
      // Allow only numeric characters and single decimal point
      if ((charCode >= 48 && charCode <= 57) || charCode === 46) {
        if (charCode === 46 && value.indexOf('.') !== -1) {
          evt.preventDefault();
          return false;
        }
        return true;
      }
      evt.preventDefault();
      return false;
    },


    validateInput(idx, isPartPrice) {
      let regex = /^\d{0,4}(\.\d{0,2})?$/;
      if (isPartPrice) {
        if (!regex.test(this.manualItems[idx].part_price)) {
          this.manualItems[idx].part_price = this.manualItems[
            idx
          ].part_price.slice(0, -1);
        }
      } else {
        if (!regex.test(this.manualItems[idx].service.price)) {
          this.manualItems[idx].service.price = this.manualItems[
            idx
          ].service.price.slice(0, -1);
        }
      }
    },


    isNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which || evt.keyCode;
      const inputElement = evt.target;
      const value = inputElement.value;
      const cursorPos = inputElement.selectionStart; // Track cursor position
      // Allow control keys
      if (charCode === 8 || charCode === 46 || charCode === 9) {
        return true;
      }
      // Restrict length to 4 characters before the decimal
      const parts = value.split('.');
      if (parts.length > 1) {
        if (parts[0].length >= 4 && cursorPos <= parts[0].length) {
          evt.preventDefault();
          return false;
        }
        // Allow up to 2 digits after the decimal point
        if (parts[1].length >= 2) {
          evt.preventDefault();
          return false;
        }
      } else if (parts[0].length >= 4 && cursorPos <= parts[0].length) {
        evt.preventDefault();
        return false;
      }
      // Allow only numeric characters and single decimal point
      if ((charCode >= 48 && charCode <= 57) || charCode === 46) {
        if (charCode === 46 && value.indexOf('.') !== -1) {
          evt.preventDefault();
          return false;
        }
        return true;
      }
      evt.preventDefault();
      return false;
    },


    replaceDollar(str) {
      return str.replace("($)", "");
    },

    disablePaste(event) {
      event.preventDefault();
    },

    deleteItemClicked(item) {
      if (item.part_price.length > 0 || item.title.length > 0) {
        this.$dialog.show({
          title: "Delete Item",
          text: "Are you sure you want to delete this item?",
          // image: "pop-req-img.png",
          // we are passing callback method for our confirm button
          onConfirm: () => {
            var index = this.manualItems.indexOf(item);
            if (index !== -1) {
              this.manualItems.splice(index, 1);
            }
          },
        });
      } else {
        var index = this.manualItems.indexOf(item);
        if (index !== -1) {
          this.manualItems.splice(index, 1);
        }
      }
    },

    nrgItemsClicked() {
      this.openModal = new Date();
      this.modal = new Modal(this.$refs.modal);
      this.modal.show();
      disableScroll()
      this.adjustConsumerModalHeight();
    },
    adjustConsumerModalHeight() {
      const modalContent = this.$refs.modal?.querySelector('.responsiveOreitationConsumerHeightAdjust');
      if (modalContent) {
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        let maxHeight;
        if (vw < 400) {
          maxHeight = vh * 0.3 - 40;
        } else if (vw < 750) {
          maxHeight = vh * 0.35 - 40;
        } else if (vw < 1440) {
          maxHeight = vh * 0.35 - 70;
        } else {
          maxHeight = vh * 0.35 - 40;
        }
        modalContent.style.maxHeight = `${maxHeight}px`;
        modalContent.style.overflowY = 'auto';
      }
    },
    nrgItemsCallback(data) {
      enableScroll()
      this.modal.hide();
      data.forEach((value) => {
        let check = this.manualItems.some(
          (vendor) => vendor.service_part_id == value.service_part_id
        );
        if (!check) {
          value.is_deletable = 1
          this.manualItems.push(value);
        }
      });
    },

    addItemManually() {
      if (this.isValid(false)) {
        const newFirstElement = {
          title: "",
          part_price: "",
          is_deletable: 1,
          service_part_id: -1,
          service: {
            price: 0,
            service_fee_title: "Service Fee ($)",
            is_service_fee_applicable: 0,
            is_service_fee_editable: 0,
          },
        };
        this.manualItems.push(newFirstElement)
        //  this.manualItems = [newFirstElement].concat(this.manualItems);
        // if (this.isPartnerQuote) {
        //   this.manualItems.splice(this.no_of_units, 0, newFirstElement);
        // } else {
        //   this.manualItems.splice(0, 0, newFirstElement);
        // }

      }
    },

    isValid(isCheckDiscount) {
      let res = true;
      this.postItems = [];
      for (let i = 0; i < this.manualItems.length; i++) {
        let eachItem = this.manualItems[i];


        if (this.isEmpty(eachItem.title)) {
          toast.error("Title field is required.");
          res = false;
          return;
        } else if (this.isEmpty(eachItem.part_price)) {
          let str =
            eachItem.service != null &&
              eachItem.service.is_service_fee_applicable == 1
              ? "Part Cost"
              : "Fee (Part + Service)";


          if (eachItem.is_evaluation_fee) {
            toast.error("Evaluation fee field is required.");
          }
          else {
            toast.error(str + " field is required.");
          }
          res = false;
          return;
        } else if (
          eachItem.service.is_service_fee_applicable == 1 &&
          this.isEmpty(eachItem.service.price)
        ) {
          toast.error("Service fee field is required.");
          res = false;
          return;
        }

        if (eachItem.is_max_markup_applicable &&
          eachItem.part_price > eachItem.max_allowed_price) {
          toast.error("Please fix price errors before saving.");
          res = false;
          return;
        }

        this.postItems.push(this.getFomattedObject(eachItem));
      }

      if (!this.isPartnerQuote && isCheckDiscount) {
        const total = this.getTotalPartPrice();
        if (this.isEmpty(this.discount)) {
          toast.error("Discount field is required.");
          res = false;
        } else if (this.discount > total) {
          toast.error("Discount cannot exceed the total amount.");
          res = false;
        }

      }
      return res;
    },

    getTotalPartPrice() {
      return this.manualItems.reduce(
        (sum, item) => sum + parseFloat(item.part_price || 0),
        0
      );
    },

    getFomattedObject(data) {
      let obj = {
        service_part_id: data.service_part_id ?? -1,
        service_fee: data.service != null ? data.service.price : 0,
        part_price: data.part_price ?? 0,
        title: data.title ?? "",
        is_evaluation_fee: data.is_evaluation_fee ?? 0,
        max_allowed_price : data.max_allowed_price
      };
      return obj;
    },

    finalizeQuoteClicked() {


      if (this.isValid(true)) {
        if (this.isPartnerQuote) {
          this.postQuoteData({
            url: "/manual-quote/partner/items/collect",
            params: {
              number_of_units: this.no_of_units,
              manual_quote_id: this.quoteDetail.id,
              items: JSON.stringify(this.postItems),
            }
          });
        } else {
          this.postQuoteData({
            url: "/manual-quote/items/collect",
            params: {
              discount: `-${this.discount}`,
              number_of_units: this.no_of_units,
              manual_quote_id: this.quoteDetail.id,
              items: JSON.stringify(this.postItems),
            }
          });
        }

      }
    },

    isEmpty(value) {
      return (
        value == null ||
        (value + "").trim().length === 0 ||
        (value.constructor === Object && Object.keys(value).length === 0)
      );
    },
  },
};
</script>

<style>
.buttonsGroup {
  display: flex;
  justify-content: center;
}

.buttonsGroup .main-button {
  background: #fe5000;
  border-radius: 8px;
  box-shadow: 0 4px 5px #999;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  padding: 10px 30px;
  margin: 0 20px;
}

.buttonsGroup .main-button:hover {
  background-color: #092e87;
  color: #fff;
}

.quoteBox-wrapp {
  padding: 15px;
  border: 2px solid #999;
  border-radius: 10px;
}

.qoutationBox-fixed {
  padding: 10px;
  border-radius: 8px;
  background-color: #d9d9d9;
  box-shadow: 0 3px 5px #0000004f;
  height: 100%;
  /* display: flex; */
  align-items: center;
  min-height: 155px;
}

.qoutationBox {
  margin-bottom: 20px;
  min-height: 180px;
  /* height: 100%; */
}

.qoutationBox-fixed h3,
.qoutationBox h3 {
  font-size: 20px;
  color: #092e87;
  font-weight: normal;
  margin-bottom: 15px;
}

.qoutationBox h3 {
  margin-bottom: 23px;
}

.qoutationBox small {
  margin-left: 18px;
  font-size: 12px;
  color: #092e87;
  font-weight: 500;
}

.qoutationBox label {
  margin-left: 18px;
  font-size: 14px;
  color: #fe5000;
  font-weight: 500;
}

.qoutationBox-fixed h2 {
  font-size: 55px;
  color: #fe5000;
  font-weight: 500;
  display: block;
}

.qoutationBox-fixed h2 span {
  font-size: 18px;
  position: relative;
  top: -15px;
}

.qoutationBox {
  padding: 10px;
  border-radius: 8px;
  background-color: #d9d9d9;
  box-shadow: 0 3px 5px #0000004f;
  padding-right: 25px;
  position: relative;
}

.quoteField {
  /* display: flex; */
}

.quoteField span {
  /* margin-right: 4px;
  color: #fe5000;
  font-size: 18px; */
}

.quoteField .form-control {
  /* height: 40px;
  font-size: 22px; */
}

.title-field .form-control {
  margin-left: 15px;
  width: calc(100% - 15px);
  margin-bottom: 5px;
}

.crossBtn {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 99;
  cursor: pointer;
}

@media screen and (max-width: 767px) {
  .buttonsGroup .main-button {
    font-size: 14px;
    padding: 10px 11px;
    margin: 0 6px;
  }
  
  .buttonsGroup .main-button {
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 440px) {
  .pricebookbtns button,
  .pricebookbtns .addmanualyitems{
    width: 100%;
  }
  .pricebookbtns{
    flex-direction: column;
    gap: 10px;
  }
}
</style>
